import { makeObservable, observable, action } from "mobx";

class SmrTableStoreV2 {
    rowHeight = 50;
    defaultDiffBetweenWindowAndTableRowsContainerHeight = 322;

    currentPage;
    pageCount;
    elementsPerPage;

    constructor(initInfo) {
        makeObservable(this, {
            currentPage: observable,
            pageCount: observable
        });

        let tmp = 1;
        if (initInfo?.elementsPerPage == null) {
            let diffBetweenWindowAndTableRowsContainerHeight =
                initInfo?.diffBetweenWindowAndTableRowsContainerHeight
                    ? initInfo.diffBetweenWindowAndTableRowsContainerHeight
                    : this.defaultDiffBetweenWindowAndTableRowsContainerHeight;
            let rowHeight = 50;
            let windowHeight = window.innerHeight;
            let tableHeight = windowHeight - diffBetweenWindowAndTableRowsContainerHeight;
            tmp = Math.trunc(tableHeight / rowHeight);
        }
        this.elementsPerPage = tmp > 0 ? tmp : 1;
        this.currentPage = 1;
        this.pageCount = 1;
    };

    GetCurrentPageStartRecordIndex() {
        return (this.currentPage - 1) * this.elementsPerPage;
    }

    HandlePagination = action((itemsCountTotal, ReloadData) => {
        this.pageCount = itemsCountTotal > this.elementsPerPage
            ? (
                Math.trunc(itemsCountTotal / this.elementsPerPage)
                + ((itemsCountTotal % this.elementsPerPage) > 0 ? 1 : 0)
            )
            : 1;

        if (this.currentPage > this.pageCount) {
            this.currentPage = this.pageCount;
            ReloadData(pageCount);
            return false;
        }

        return true;
    })

    HandleComponentDidUpdate(tableRowsContainerNode, ReloadData) {
        if (tableRowsContainerNode != null) {
            let tableHeight = tableRowsContainerNode.offsetHeight;
            let newElementsPerPage = Math.trunc(tableHeight / this.rowHeight);
            if (this.elementsPerPage != newElementsPerPage) {
                this.elementsPerPage = newElementsPerPage;
                ReloadData();
            }
        }
    }
}

export default SmrTableStoreV2;